import { render, staticRenderFns } from "./revisao.vue?vue&type=template&id=679a08c7&scoped=true&"
import script from "./revisao.vue?vue&type=script&lang=js&"
export * from "./revisao.vue?vue&type=script&lang=js&"
import style0 from "./revisao.vue?vue&type=style&index=0&id=679a08c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679a08c7",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFlex: require('@chakra-ui/vue').CFlex})
